<template>
  <div class="connect-task-panel">
    <div class="task-sub-top">
      <i class="icon iconfont iconicon_associated_tasks"></i>
      <span>关联任务</span>
    </div>
    <div class="connect-list">
      <p class="connect-prepost" v-if="posPre_tasks.pre_tasks && posPre_tasks.pre_tasks.length > 0">
        <span>前置任务</span>
        0/{{posPre_tasks.pre_tasks.length}}
      </p>
      <template v-for="(item) in posPre_tasks.pre_tasks">
        <div
          class="connect-list-item"
          :key="item.id"
          :class="{
            'complete-style': item.associated_task ? isComplateFn(item) : false,
          }"
        >
          <el-checkbox
            v-model="item.isComplate"
            @change="finishTask(item)"
            :disabled="true"
          ></el-checkbox>
          <div class="connnect-list-left">
            <toolTip
              :maxWidth="'323px'"
              :title="item.task_name"
              @click.native="openedTask(item)"
            >
              {{ item.task_name }}
            </toolTip>
          </div>
          <div class="connnect-list-right">
            <div class="end-time" v-if="item.end_time" :class="dateReminder(item)">{{item.end_time.replace(/-/g,'/')}}</div>
            <div class="end-time" v-else>暂无日期</div>
            <div class="connct-avatar">
              <img class="img-nor" width="28" height="28" src="image/executor.png" alt="">
            </div>
            <div class="more" @click.stop>
              <el-dropdown size="small" trigger="click">
                <i class="icon iconfont iconicon_user_more_task"></i>
                <el-dropdown-menu slot="dropdown" class="task-panel-right-more">
                  <el-dropdown-item command="del" @click.native="delConnect(item,'front')">
                    <i class="icon iconfont iconicon_disconnect"></i>
                    解除关联
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </template>

      <div class="line" v-if="posPre_tasks.post_tasks && posPre_tasks.post_tasks.length > 0 && posPre_tasks.pre_tasks && posPre_tasks.pre_tasks.length > 0"></div>
      <p class="connect-prepost"  v-if="posPre_tasks.post_tasks && posPre_tasks.post_tasks.length > 0">
        <span>后置任务</span>
        0/{{posPre_tasks.post_tasks.length}}
      </p>

      <template v-for="(item) in posPre_tasks.post_tasks">
        <div
          class="connect-list-item"
          :key="item.id"
        >
          <el-checkbox
            v-model="item.isComplate"
            @change="finishTask(item)"
            :disabled="true"
          ></el-checkbox>
          <div class="connnect-list-left">
            <toolTip
              :maxWidth="'323px'"
              :title="item.task_name"
              @click.native="openedTask(item)"
            >
              {{ item.task_name }}
            </toolTip>
          </div>
          <div class="connnect-list-right">
            <div class="end-time" v-if="item.end_time" :class="dateReminder(item || {})">{{item.end_time.replace(/-/g,'/')}}</div>
            <div class="end-time" v-else>暂无日期</div>
            <div class="connct-avatar">
              <img class="img-nor" width="28" height="28" src="image/executor.png" alt="">
            </div>
            <div class="more" @click.stop :style="{'visibility': 'visible'}">
              <el-dropdown size="small" trigger="click">
                <i class="icon iconfont iconicon_user_more_task"></i>
                <el-dropdown-menu slot="dropdown" class="task-panel-right-more">
                  <el-dropdown-item command="del" @click.native="delConnect(item,'behind')">
                    <i class="icon iconfont iconicon_disconnect"></i>
                    解除关联
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </template>
      <el-popover
        ref="popover"
        v-model="visible"
        placement="top-start"
        width="590"
        trigger="manual"
        popper-class="connect-add-popover"
      >
        <div class="connect-dialog">
          <div class="top">
            <div class="banner">
              <span :class="{'top-active':associated_type === 'front'}" @click="connectChange('front')">前置任务</span>
              <span :class="{'top-active':associated_type === 'behind'}" @click="connectChange('behind')">后置任务</span>
            </div>
            <el-input class="top-search" prefix-icon="icon iconfont iconicon_search1" v-model="formData.keyword" size="mini" placeholder="输入要关联的任务名称" clearable @input="searchInput"></el-input>
          </div>
          <div class="tree-list"  :infinite-scroll-immediate="false">
            <el-tree v-if="show" ref="tree" :data="selectTask" :props="props" show-checkbox check-on-click-node :expand-on-click-node="false" :check-strictly="true" node-key="id" @check="checkChange"  :filter-node-method="filterNode">
              <div class="tree-name-box" slot-scope="{ node,data }">
                <div class="box-left">
                  <toolTip class="task-name" maxWidth="60%" :title="node.task_name">{{data.task_name}}</toolTip>
                  <span class="finish-tip" v-if="front.some(id => id === data.id) && associated_type === 'behind'">前置</span>
                  <span class="finish-tip" v-if="behind.some(id => id === data.id) && associated_type === 'front'">后置</span>
                </div>
                <div class="box-right">
                  <div class="end-time" v-if="data.end_time" :class="dateReminder(data)">{{data.end_time.replace(/-/g,'/')}}</div>
                  <div class="end-time" v-else>暂无日期</div>
                  <div class="connct-avatar">
                    <img class="img-nor" width="28" height="28" src="image/executor.png" alt="">
                  </div>
                </div>
              </div>
            </el-tree>
            <div class="connect-loading">
              <i class="el-icon-loading" v-if="loading"></i>
            </div>
            <nothing v-if="selectTask && selectTask.length === 0" :config="{ tip: '暂无此任务' }"></nothing>
          </div>
          <div class="connect-bottom">
            <span class="tis">已选择{{front.length}}个前置任务，{{behind.length}}个后置任务</span>
            <div class="connect-bottom-btns">
              <span class="cancel text-btn-active" @click="visible = false">取消</span>
              <wf-button :disabled="front.length === 0 && behind.length === 0" @click="addConnect">保存</wf-button>
            </div>
          </div>
        </div>
        <div ref="task-sub-bottom" class="task-sub-bottom" slot="reference" @click.stop="visible = !visible" >
          <i class="icon iconfont iconicon_enlarge" style="margin-right:8px;"></i>添加关联任务
          <el-input ref="hashInput" class="add-box-input" type="textarea" v-model="taskName" size="mini"></el-input>
        </div>
      </el-popover>
      <!-- <p class="not-thing" v-if="">暂无关联任务~</p> -->
    </div>
  </div>
</template>

<script>
import api from '@/services/api/connect/connect'
import apiTask from '@/services/api/task/task';
import bus from '@/bus'
import { dateReminder } from '@/utils'
import { mapState } from 'vuex'

export default {
  props: {
    project_id: {
      type: [Number, String],
      default: ''
    },
    editData: {
      type: Object,
      default: () => {}
    },
    primission: {
      type: Boolean,
      default: false
    },
    association_dependency: {
      type: [Object, Array],
      default: () => { }
    },
    addPrimission: Boolean
  },
  data() {
    return {
      associated_type: 'front',
      front: [],
      behind: [],
      treeData: [],
      taskName: '',
      show: true,
      formData: {
        number: 20,
        page: 1,
        keyword: '',
        project_id: '',
        ignore_task_id: ''
      },
      props: {
        label: 'task_name',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      loading: false,
      finish: false,
      lastNodeId: '',
      dataNothing: false,
      visible: false
    }
  },
  computed: {
    ...mapState('template/template', {
      taskListData: state => state.dataset?.project_template_content.task_list
    }),
    dataset() {
      let towArrIn =  this.taskListData.map(res => {
        let childrenArr = []
        res?.tasks?.map(temp => {
          if(temp?.children && temp?.children.length > 0) {
            let arr = temp.children.filter(res => res.id !== this.editData.id )
            childrenArr.push(...arr)
          }
        })
        let arr = res?.tasks?.filter(res => res.id !== this.editData.id) || []
        console.log(arr)
        return [...arr, ...childrenArr]
      })
      return towArrIn.flat()
    },
    selectTask() {
      let towArrIn =  this.taskListData?.map(res => {
        let arr = res?.tasks?.filter(temp => temp.id !== this.editData.id && temp.id !== this.editData.pid)
        return arr
      }) || []
      return towArrIn.flat()
    },
    posPre_tasks() {
      return {
        pre_tasks: this.dataset.filter(res => this.association_dependency?.pre_tasks?.indexOf(res.id) > -1) || [],
        post_tasks: this.dataset.filter(res => this.association_dependency?.post_tasks?.indexOf(res.id) > -1) || [],
      }
    }
  },
  watch: {
    editData: {
      handler() {
        this.filterData()
      },
      deep: true
    }
  },
  mounted() {
    this.filterData()
    document.addEventListener('click', () => {
      this.visible = false
    })
  },
  destroyed() {
    document.removeEventListener('click', () => {
      this.visible = false
    })
  },
  methods: {
    filterData() {
      this.front = this.association_dependency.pre_tasks || []
      this.behind = this.association_dependency.post_tasks || []
      this.$nextTick(() => {
        this.$refs.tree ? this.$refs.tree.setCheckedKeys(this[this.associated_type]) : ''
      })
    },
    mapIsLeaf(data) {
      data.map(val => {
        // val.disabled = val.task_stage === '已完成'
        val.isCompete = val.task_stage === '已完成'
        val.isArch = val.task_stage === '已归档'
        val.isLeaf = val.children_task_count === 0
      })
      return data
    },
    async finishTask(item) {
      // console.log(item, 11111)
      if (item.task_stage === '已归档') return
      let newVal = item.isComplate ? '已完成' : '进行中'
      await apiTask.updateTaskStage({ task_id: item.associated_task_id, task_stage: newVal })
      this.$emit('change')
    },
    // 归档任务操作
    handleArchive(item, type) {
      this.$emit('handleArchive', item.associated_task_id, type)
    },
    connectChange(fl) {
      this.associated_type = fl
      this.$refs.tree.setCheckedKeys(this[fl])
    },
    checkChange(data) {
      // let arr = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedKeys()))
      // console.log('-------------------', data, new Set([...this.front,...arr]))
      // let id = data.id
      if (this.associated_type === 'front') {
        // this.front = [...new Set([...this.front,...arr])]
        let fl = this.front.findIndex(res => res === data.id)
        fl > -1 ? this.front.splice(fl, 1) : this.front.push(data.id)
        let index = this.behind.findIndex(id => id === data.id)
        index > -1 ? this.behind.splice(index, 1) : ''
      } else {
        // this.behind = [...new Set([...this.behind,...arr])]
        let fl = this.behind.findIndex(res => res === data.id)
        fl > -1 ? this.behind.splice(fl, 1) : this.behind.push(data.id)
        let index = this.front.findIndex(id => id === data.id)
        index > -1 ? this.front.splice(index, 1) : ''
      }
    },
    getArrayUnion(arr1,arr2) {
      const mergedArr =[...arr1, ...arr2].reduce((acc,cur) => {
        if (!acc.some(item => item.id === cur.id)) {
          acc.push(cur);
        }
          return acc;
      },[])
      return mergedArr
    },
    async addConnect() {
      let params = {
        pre_tasks: this.front,
        post_tasks: this.behind,
      }
      this.visible = false
      this.$emit('change', params)
    },
    async delConnect(item, str) {
      let text = str === 'front' ? '前置' : '后置'
      this.$wfAlert('warning', `确定解除关联此${text}任务吗`, '', '确定').then(async () => {
        this[str].splice(this[str].indexOf(item.id), 1)
        console.log('----------',str ,this[str], item.id,this[str].indexOf(item.id))
        let params = {
          pre_tasks: this.front,
          post_tasks: this.behind,
        }
        // this.addConnect()
        this.$emit('del', item.id, params)
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    searchInput() {
      this.$refs.tree.filter(this.formData.keyword)
    },
    dateReminder(item) {
      let result = dateReminder(item)
      if (result === 'complete') {
        return 'complete-time complete'
      } else if (result === 'expired') {
        return 'complete-time expired'
      } else if (result === 'remind') {
        return 'complete-time remind'
      } else {
        return 'children-row complete-time'
      }
    },
    opendPopover() {
      this.visible = !this.visible
      if (this.visible) {
        this.$refs.hashInput.focus()
      }
    },
    // 判断是否已完成
    isComplateFn(item) {
      const _item = item.associated_task
      return _item.task_stage === '已归档' ? _item.before_archiving_is_completed : _item.task_stage === '已完成'
    },
    showItem(val,data, temp) {
      console.log(val, data, temp)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.task_name.indexOf(value) !== -1;
    },
    openedTask(item) {
      this.$emit('openedTask', item)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.connect-dialog {
  padding: 0;
  .connect-loading {
    padding-left: 24px;
    height: 20px;
    line-height: 20px;
  }
  .el-tree .el-tree-node__content {
    height: 40px !important;
    line-height: 40px !important;
    font-size: 14px;
    &:hover {
      background: #f7f8f9;
    }
    &:active {
      background: #eaebec;
    }
  }
  .top {
    padding: 26px 26px 16px 26px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgba(231, 232, 237, 0.6);
    .banner {
      justify-content: flex-start;
      display: flex;
      color: rgba(32, 32, 32, 0.6);
      margin-bottom: 26px;
      span {
        cursor: pointer;
        margin-right: 30px;
      }
    }
    .top-active {
      color: initial;
    }
  }
  .tree-list {
    height: 332px;
    padding: 8px 0;
    box-sizing: border-box;
    overflow-x: hidden;
    position: relative;
    .el-tree-node {
      margin-bottom: 8px;
    }
  }
  .connect-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    padding: 0 16px;
    border-top: 1px solid rgba(231, 232, 237, 0.6);
    .tis {
      @include fontColorOpacity(.6);
    }
  }
  .connect-bottom-btns {
    display: flex;
    align-items: center;
    .cancel {
      margin-right: 24px;
    }
  }
  .tree-name-box {
    display: flex;
    width: 100%;
    .box-left {
      font-size: 14px;
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
    }
    .box-right {
      margin-right: 16px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      .connct-avatar {
        display: flex;
        align-items: center;
      }
    }
    .task-name {
    }
    .from-tip {
      padding: 4px;
      background-color: #f7f8f9;
      border-radius: 4px;
      color: rgba(32, 32, 32, 0.6);
      margin-left: 19px;
      display: block;
      height: 24px;
      line-height: 24px;
      flex-shrink: 0;
    }
    .finish-tip {
      width: 46px;
      height: 20px;
      @include bgColorOpacity(.16);
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #202020;
      margin-left: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .complete-node {
    opacity: 0.4;

  }
  .complete-node-arch {
    opacity: 0.4;
    // .task-name {
    //   text-decoration: line-through;
    // }
  }
  .end-time {
    flex-shrink: 0;
    color: #75748e;
    width: 94px;
  }
}
.connect-task-panel {
  .task-badge {
    width: 6px;
    height: 6px;
    background: linear-gradient(270deg, #6b97cf 0%, #456fb3 100%);
    border-radius: 50%;
    margin-right: 10px;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 4px;
  }
  .connect-list {
    border: 1px solid rgba(32, 32, 32, 0.08);
    border-radius: 4px;
    .connect-list-item:last-child {
      margin: 0;
    }
    .not-thing {
      margin: 0 16px;
      color: #999;
      height: 54px;
      line-height: 54px;
    }
  }
  .line {
    height: 1px;
    background: rgba(231, 232, 237, 0.6);
    margin: 8px 16px 0;
  }
  .connect-prepost {
    @include fontColorOpacity(.6);
    font-size: 14px;
    padding: 0 16px;
    height: 50px;
    line-height: 50px;
    span {
      margin-right: 8px;
    }
  }
  .task-sub-top {
    font-size: 16px;
    line-height: 1;
    padding-top: 24px;
    padding-bottom: 16px;
    i {
      margin-right: 6px;
    }
  }
  .task-sub-bottom {
    display: flex;
    font-size: 14px;
    align-items: center;
    color: $color-active;
    cursor: pointer;
    display: inline-block;
    position: relative;
    margin-left: 16px;
    height: 54px;
    line-height: 54px;
    .add-box-input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }
    i {
      margin-right: 8px;
      font-size: inherit;
    }
  }
  // .complete-style {
  //   .connnect-list-left,
  //   .end-time,
  //   .connct-avatar {
  //     opacity: 0.4;
  //   }
  //   .el-checkbox {
  //     opacity: 1;
  //   }
  //   .more {
  //     opacity: 1;
  //   }
  // }
  .connect-list-item {
    position: relative;
    min-height: 48px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    &:hover {
      @include bgColorOpacity(.04);
    }
    &:active {
      @include bgColorOpacity(.08);
    }
    &.filed-style,
    &.complete-style {
      // &.filed-style {
      //   @include bgColorOpacity(.08);
      //   &:hover {
      //     @include bgColorOpacity(.04);
      //   }
      // }
      @include fontColorOpacity(.4);
      cursor: not-allowed;
      .task-title {
        &:hover {
          color: #202020;
        }
      }
      .child-time {
        &:hover {
          background: none;
        }
      }
      .end-time {
        @include fontColorOpacity(.4);
      }
      .connct-avatar {
        opacity: .4;
      }
      .more {
        cursor: pointer;
      }
    }
    .more {
      margin-top: 0 !important;
      margin-left: 14px;
    }
    .connnect-list-left {
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 16px;
      box-sizing: border-box;
    }
    .archive-icon {
      display: block;
      width: 46px;
      height: 20px;
      @include bgColorOpacity(.06);
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;
      @include fontColorOpacity(.4);
      margin-left: 8px;
    }
    .connnect-list-right {
      display: flex;
      align-items: center;
      margin-left: 27px;
      .connct-avatar {
        margin-left: 14px;
      }
      .img-nor {
        line-height: 45px;
      }
      i {
        cursor: pointer;
        flex-shrink: 0;
        font-size: 14px;
      }
    }
  }
  .end-time {
    text-align: right;
    @include fontColorOpacity(.8);
    flex-shrink: 0;
    width: 86px;
  }
}
.connect-add-popover {
  .el-tree__empty-block {
    display: none;
  }
}
</style>
